export const LEAD_STATUS = {
  NUEVO: 'nuevo',
  CONTACTADO: 'contactado',
  EN_SEGUIMIENTO: 'en_seguimiento',
  CALIFICADO: 'calificado',
  PROPUESTA: 'propuesta',
  GANADO: 'ganado',
  PERDIDO: 'perdido',
  CONVERTIDO: 'convertido',
  DESCARTADO: 'descartado',
} as const;

export type LeadStatusKey = typeof LEAD_STATUS[keyof typeof LEAD_STATUS];

export const LEAD_STATUS_LABELS: Record<LeadStatusKey, string> = {
  nuevo: 'Nuevo',
  contactado: 'Contactado',
  en_seguimiento: 'En seguimiento',
  calificado: 'Calificado',
  propuesta: 'Propuesta',
  ganado: 'Ganado',
  perdido: 'Perdido',
  convertido: 'Convertido',
  descartado: 'Descartado',
};

export const LEAD_STATUS_COLORS: Record<LeadStatusKey, string> = {
  nuevo: 'bg-blue-100 text-blue-800',
  contactado: 'bg-yellow-100 text-yellow-800',
  en_seguimiento: 'bg-amber-100 text-amber-800',
  calificado: 'bg-green-100 text-green-800',
  propuesta: 'bg-purple-100 text-purple-800',
  ganado: 'bg-emerald-100 text-emerald-800',
  perdido: 'bg-red-100 text-red-800',
  convertido: 'bg-emerald-100 text-emerald-800',
  descartado: 'bg-gray-100 text-gray-800',
};

export const CONTACT_LEAD_STATUS = {
  ...LEAD_STATUS,
  YA_ES_CLIENTE: 'ya_es_cliente',
  INACTIVO: 'inactivo',
} as const;

export const LEAD_STATUS_INTERNAL = {
  ...LEAD_STATUS,
  ARCHIVADO: 'archivado',
} as const;
